export interface BackstageOnlineEditContext {
  accessToken: string
  enterpriseId: string
  orderId: string
  opBy: string
  from: 'backstage'
}

const STORAGE_KEY = 'backstage_online_edit_context'
const BACKSTAGE_SOURCE = 'backstage'

const canUseBrowserStorage = () =>
  typeof window !== 'undefined' && typeof window.sessionStorage !== 'undefined'

const parseContext = (
  value: string | null,
): BackstageOnlineEditContext | null => {
  if (!value) return null
  try {
    const context = JSON.parse(value) as BackstageOnlineEditContext
    if (
      context?.from === BACKSTAGE_SOURCE &&
      context.accessToken &&
      context.enterpriseId
    ) {
      return context
    }
  } catch (error) {
    console.error('读取后台编辑上下文失败:', error)
  }
  return null
}

export const getBackstageOnlineEditContext =
  (): BackstageOnlineEditContext | null => {
    if (!canUseBrowserStorage()) return null
    return parseContext(window.sessionStorage.getItem(STORAGE_KEY))
  }

export const setBackstageOnlineEditContext = (
  context: BackstageOnlineEditContext,
) => {
  if (!canUseBrowserStorage()) return
  window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(context))
}

export const clearBackstageOnlineEditContext = () => {
  if (!canUseBrowserStorage()) return
  window.sessionStorage.removeItem(STORAGE_KEY)
}

export const getBackstageOnlineEditAccessToken = () => {
  return getBackstageOnlineEditContext()?.accessToken || ''
}

export const getBackstageOnlineEditEnterpriseId = () => {
  return getBackstageOnlineEditContext()?.enterpriseId || ''
}

export const getBackstageOnlineEditOperatorName = () => {
  return getBackstageOnlineEditContext()?.opBy || ''
}

export const isBackstageOnlineEdit = () => {
  if (typeof window !== 'undefined') {
    const params = new URLSearchParams(window.location.search)
    if (params.get('from') === BACKSTAGE_SOURCE) return true
  }
  return getBackstageOnlineEditContext()?.from === BACKSTAGE_SOURCE
}

export const initBackstageOnlineEditContextFromUrl = () => {
  if (typeof window === 'undefined') return null

  const url = new URL(window.location.href)
  if (url.searchParams.get('from') !== BACKSTAGE_SOURCE) {
    return getBackstageOnlineEditContext()
  }

  const accessToken = url.searchParams.get('accessToken') || ''
  const enterpriseId = url.searchParams.get('enterpriseId') || ''
  const context: BackstageOnlineEditContext | null =
    accessToken && enterpriseId
      ? {
          accessToken,
          enterpriseId,
          orderId: url.searchParams.get('id') || '',
          opBy: url.searchParams.get('opBy') || '',
          from: BACKSTAGE_SOURCE,
        }
      : null

  if (context) setBackstageOnlineEditContext(context)
  url.searchParams.delete('accessToken')
  window.history.replaceState(
    window.history.state,
    document.title,
    `${url.pathname}${url.search}${url.hash}`,
  )
  return context
}
